/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Join_DiscordInputs */

const en_nav_join_discord = /** @type {(inputs: Nav_Join_DiscordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join our Discord`)
};

const zh_hans1_nav_join_discord = /** @type {(inputs: Nav_Join_DiscordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入我们的 Discord`)
};

const pt_br2_nav_join_discord = /** @type {(inputs: Nav_Join_DiscordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre no nosso Discord`)
};

const es_nav_join_discord = /** @type {(inputs: Nav_Join_DiscordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a nuestro Discord`)
};

const fr_nav_join_discord = /** @type {(inputs: Nav_Join_DiscordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoindre notre Discord`)
};

const de_nav_join_discord = /** @type {(inputs: Nav_Join_DiscordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unserem Discord beitreten`)
};

const ru_nav_join_discord = /** @type {(inputs: Nav_Join_DiscordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наш Discord`)
};

const it_nav_join_discord = /** @type {(inputs: Nav_Join_DiscordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entra nel nostro Discord`)
};

/**
* | output |
* | --- |
* | "Join our Discord" |
*
* @param {Nav_Join_DiscordInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const nav_join_discord = /** @type {((inputs?: Nav_Join_DiscordInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Join_DiscordInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_nav_join_discord(inputs)
	if (locale === "pt-BR") return pt_br2_nav_join_discord(inputs)
	if (locale === "es") return es_nav_join_discord(inputs)
	if (locale === "fr") return fr_nav_join_discord(inputs)
	if (locale === "de") return de_nav_join_discord(inputs)
	if (locale === "ru") return ru_nav_join_discord(inputs)
	if (locale === "it") return it_nav_join_discord(inputs)
	return en_nav_join_discord(inputs)
});